import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { EyeSlash, Lock, LockFill, Pencil } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import { LoadingComponent } from "../components/LoadingComponent";
import { useProfile } from "../components/ProfileContext";
import { Survey } from "../models/Survey";
import { getDB } from "../util/db";
import { emptyArray, positionSort, setNavAdvisoryLockout } from "../util/utils"

export function SurveyListPage(props) {
	setNavAdvisoryLockout(false);

	let [surveys, setSurveys] = useState(null);
	let isLoading = (surveys == null);
	let [profile] = useProfile();
	
	useEffect(async () => {
		if(isLoading) {
			let db = await getDB();
			let activeSurveys = await Survey.getActiveSurveys();
			// Sort the component types by position
			activeSurveys = activeSurveys.map(survey => {
				return {
					...survey,
					surveyComponentTypes: survey.surveyComponentTypes.toSorted( (a, b) => {return a.position - b.position} )
				};
			})
			setSurveys(activeSurveys);
		}
	});

	if(isLoading) {
		return <LoadingComponent />;
	}

	return (
		<div>
			<div className="headerOnlyContainer">
				<h1>
					Edit Surveys
					<Link className="float-end" to="/surveys/new"><Button>New Survey</Button></Link>
				</h1>
				<div className="clearfix"></div>
			</div>
			<div className="table-responsive">
				<table className="table">
					<thead>
						<tr>
							<td></td>
							<th>Name</th>
							<th>Component Types</th>
							<th>Category</th>
							<th>Global</th>
						</tr>
					</thead>
					<tbody>
						{surveys.map(survey => <SurveyListRow key={survey.id} survey={survey} profile={profile} />)}
					</tbody>
				</table>
			</div>
		</div>
	);
}

function SurveyListRow(props) {
	let profile = props.profile;
	let survey = props.survey;
	let editable = (survey["userIdentifier"] == profile.id.toString()) || profile.admin;
	let navigate = useNavigate();

	let duplicateSurveyAction = async () => {
		if(!confirm("Are you sure you want to duplicate this survey?")) {
			return;
		}

		try {
			let newSurvey = await Survey.adminDuplicateSurvey(survey, profile);
			navigate(`/surveys/${newSurvey.id}`);
		} catch(err) {
			alert(`Error saving new job: ${err}`);
		}
	};
	
	return <tr>
		<td>
			{editable && <Link className="float-start" to={`/surveys/${survey.id}`}><Pencil /></Link>}
			{!editable && <Lock className="float-start mt-3" />}
			<Button variant="warning" className="float-start ms-4 d-none d-md-block" onClick={duplicateSurveyAction}>Duplicate</Button>
		</td>
		<td>{survey.name}</td>
		<td>{ survey.surveyComponentTypes.map(ct => {return ct.componentType.name}).join(", ") } </td>
		<td> {survey.categoryName} </td>
		<td>{survey.global ? "Y" : "N"}</td>
	</tr>;
}